var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('img',{staticClass:"atom-company-logo",class:{large: _vm.large},attrs:{"src":_vm.url,"aria-hidden":"true"}})}
var staticRenderFns = []

export { render, staticRenderFns }